var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isReadOnly
    ? _c("div", [
        _c("div", { staticClass: "row mt-4 mb-5 ml-2" }, [
          _c(
            "div",
            { staticClass: "col-md-3 col col-sm-6" },
            [
              _c("total-amount-view", {
                attrs: {
                  amount: _vm._f("price")(_vm.getStringAmount),
                  icon: "fa fa-usd-circle",
                  "icon-color": "color-yellow-star",
                  title: "Reembolso Solicitado:"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-3 col col-sm-6 mt-3 mt-md-0 mt-sm-3" },
            [
              _c("total-amount-view", {
                attrs: {
                  amount: _vm._f("price")(_vm.model.adjustmentsTotal),
                  icon: "fa fa-usd-circle",
                  "icon-color": "color-primary-8",
                  title: "Ajuste Realizado:"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "col-md-3 col col-sm-6 mt-md-0 mt-sm-3 mt-3 mt-md-0 mt-sm-3"
            },
            [
              _c("total-amount-view", {
                attrs: {
                  amount: _vm._f("price")(_vm.model.amountToRefund),
                  icon: "fa fa-usd-circle",
                  "icon-color": "color-green",
                  title: "Total a Reembolsar:"
                }
              })
            ],
            1
          ),
          _vm.data.isOneTimePayment
            ? _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col col-sm-6 mt-md-0 mt-sm-3 mt-3 d-flex align-items-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill one-time-badge px-3 py-2 font-14"
                    },
                    [_vm._v(" One Time Payment ")]
                  )
                ]
              )
            : _vm._e()
        ]),
        _c(
          "div",
          [
            _c("section-title", {
              attrs: { "has-line": true, title: "Resumen General" }
            }),
            _c(
              "custom-callout",
              {
                staticClass: "mb-4 custom-callout bg-white",
                attrs: { "has-border": false, "has-toggle": false }
              },
              [
                _c(
                  "div",
                  { staticClass: "row py-2 mr-md-0 align-items-start" },
                  [
                    _c("div", { staticClass: "col-md-1 mt-5" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column font-weight-bold mt-n5 ml-n4 mt-sm-n5 ml-sm-n4 align-items-center"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "dot d-flex justify-content-center align-items-center py-2 px-1 mt-2"
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "orange-icon orange-icon-badge-align fas fa-donate"
                              })
                            ]
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-md-11" }, [
                      _c("div", { staticClass: "row mb-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "data-title d-block border-mobile font-weight-bold"
                            },
                            [_vm._v(" Periodo a Reembolsar: ")]
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            _vm._l(_vm.model.periods, function(period, index) {
                              return _c(
                                "div",
                                {
                                  key: `period-${index}`,
                                  staticClass: "round-element mx-1"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-16 color-black text-nowrap font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("uppercase")(
                                              period.periodName
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            !_vm.data.isAdditionalPayment
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "data-title d-block border-mobile mb-3"
                                  },
                                  [
                                    _vm._v(
                                      " Desglose de los gastos solicitados en el " +
                                        _vm._s(_vm.typeName) +
                                        " para el periodo seleccionado: "
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "data-title d-block border-mobile"
                                  },
                                  [_vm._v(" Detalle del pago adicional: ")]
                                ),
                            _vm.model &&
                            _vm.model.selectedServices.length == 0 &&
                            !_vm.data.isAdditionalPayment
                              ? _c(
                                  "p",
                                  { staticClass: "font-14 color-black" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.model.comment) + " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.model && _vm.data.isAdditionalPayment
                              ? _c(
                                  "div",
                                  { staticClass: "font-14 color-black" },
                                  [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "data-title d-block border-mobile"
                                        },
                                        [_vm._v(" Cantidad del Pago: ")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "font-16 color-black" },
                                        [
                                          _vm._v(
                                            " $ " +
                                              _vm._s(_vm.model.amount) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "data-title d-block border-mobile"
                                        },
                                        [_vm._v(" Razón para el Pago: ")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "font-16 color-black" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.model
                                                  .additionalPaymentReason
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _c("request-services", {
                              attrs: {
                                "is-mobile": _vm.isMobile,
                                items: _vm.model.selectedServices,
                                "read-only": true
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c("section-title", {
              attrs: { "has-line": true, title: "Documentos" }
            }),
            _c(
              "div",
              { staticClass: "mt-2 custom-document-info" },
              [
                _c(
                  "custom-callout",
                  { attrs: { "has-border": false, "has-toggle": false } },
                  [
                    _c("div", { staticClass: "row col-12" }, [
                      _c("div", { staticClass: "row col-8" }, [
                        _c("div", { staticClass: "row col-12 col-md-6" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "span",
                              {
                                staticClass: "data-title d-block border-mobile"
                              },
                              [_vm._v(" Documento: ")]
                            ),
                            _c("span", { staticClass: "font-16 color-black" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")("Carta de Autorización")
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-4 d-flex align-items-center justify-content-end"
                        },
                        [
                          _c("action-button", {
                            staticClass: "px-1 mx-1 download-btn",
                            attrs: {
                              i: "fas fa-file-download pl-2 m-0",
                              variant: "success"
                            },
                            on: { click: _vm.onDownloadRefundReport }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._l(_vm.filteredDocuments, function(document, index) {
              return _c(
                "div",
                { key: `document-${index}` },
                [
                  !_vm.isReimbursementCertification(document.documentTypeId) ||
                  document.documentId
                    ? _c("DocumentView", {
                        attrs: {
                          comment: document.comment,
                          "document-file-name": document.documentFilename,
                          "document-id": document.documentId,
                          "document-name": document.documentTypeName,
                          "document-type-id": document.documentTypeId,
                          "request-id": _vm.model.requestId,
                          "show-replace-button":
                            !_vm.isServiceProposal(document.documentTypeId) &&
                            !_vm.isReimbursementCertification(
                              document.documentTypeId
                            )
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            })
          ],
          2
        )
      ])
    : _c(
        "div",
        [
          _c(
            "validation-observer",
            { ref: "formRef" },
            [
              _c("section-title", {
                staticClass: "mt-4",
                attrs: {
                  id: "reinbursement-selection-title",
                  "has-line": "",
                  title: _vm.isDirectPayment
                    ? "Selección de Periodo para Pago Directo"
                    : _vm.data.isAdditionalPayment
                    ? "Periodo para Pago Adicional"
                    : "Selección de Periodo para Reembolso"
                }
              }),
              _c("historial-accordion", {
                staticClass: "mt-3 mx-auto",
                attrs: {
                  id: "reinbursement-period",
                  "checkbox-container-class": "pb-2",
                  items: _vm.historialItems,
                  "topic-text": "Periodo:",
                  "topic-text-class": "font-weight-bold font-18"
                },
                on: { "on-checked-historial-item": _vm.updateItems }
              }),
              _c("section-title", {
                staticClass: "mt-4",
                attrs: {
                  id: "reinbursement-service-amount-title",
                  "has-line": "",
                  title: _vm.isDirectPayment
                    ? "Información del Pago Directo"
                    : _vm.data.isAdditionalPayment
                    ? "Información del Pago"
                    : "Información del Reembolso"
                }
              }),
              !_vm.data.isAdditionalPayment
                ? _c(
                    "div",
                    {
                      staticClass:
                        "row menu rounded jumbo bg-light mt-4 p-4 mx-auto"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "color-black font-16 col-12" },
                        [
                          _vm._v(
                            " Servicios autorizados por la Secretaría Asociada de Educación Especial. "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "my-3 col-12" },
                        [
                          !_vm.showNotServicesAvaiableMessage &&
                          !_vm.hasFoundServices
                            ? _c(
                                "div",
                                [
                                  _c("CustomError", {
                                    attrs: {
                                      "is-alert-mode": "",
                                      message:
                                        "Para visualizar  los servicios favor de seleccionar el período correspondiente"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showNotServicesAvaiableMessage
                            ? _c(
                                "div",
                                { staticClass: "mb-2" },
                                [
                                  _c("CustomError", {
                                    attrs: {
                                      message:
                                        "Para el período seleccionado no se encontró una consulta vigente",
                                      variant: "no-border"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.servicesKey > 0
                            ? _c("request-services", {
                                key: _vm.servicesKey,
                                attrs: {
                                  "is-mobile": _vm.isMobile,
                                  items: _vm.model.services,
                                  "request-status-id": _vm.model.statusId,
                                  "selected-month-number": _vm.selectedMonth
                                },
                                on: {
                                  "on-select-services":
                                    _vm.onSelectServiceHandler,
                                  "update-amount": _vm.onUpdateAmountHandler
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("validation-provider", {
                        staticClass: "col-12 px-0",
                        attrs: {
                          "custom-messages": {
                            required_if: _vm.isDirectPayment
                              ? "El monto para pago directo es requerido."
                              : "El monto a reembolsar es requerido."
                          },
                          rules: { required_if: !_vm.model.amount }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  errors[0] && errors[0].length > 0
                                    ? _c("CustomError", {
                                        attrs: {
                                          message: errors[0],
                                          variant: "no-border"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3641902545
                        )
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "row menu rounded jumbo bg-light mt-4 p-4 mx-auto"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required|min_value:1" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Entre la cantidad para el pago",
                                        error: errors[0],
                                        label: "Cantidad del Pago",
                                        "mask-type": "Money",
                                        type: "number"
                                      },
                                      model: {
                                        value: _vm.model.amount,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "amount", $$v)
                                        },
                                        expression: "model.amount"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        id: "comment",
                                        "custom-error-msg":
                                          "Por favor describa la razón para el pago",
                                        error: errors[0],
                                        label: "Razón para el Pago",
                                        maxlength: 3000,
                                        name: "comment",
                                        "show-char-count": true
                                      },
                                      model: {
                                        value:
                                          _vm.model.additionalPaymentReason,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "additionalPaymentReason",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.additionalPaymentReason"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ]
                  )
            ],
            1
          ),
          _c(
            "validation-observer",
            { ref: "documentFormRef" },
            [
              _c("section-title", {
                staticClass: "mt-4",
                attrs: {
                  id: "reinbursement-document-title",
                  "has-line": "",
                  title: "Documentos"
                }
              }),
              _vm.data.determinationId == 3
                ? _c(
                    "custom-callout",
                    { attrs: { "has-border": false, "has-toggle": false } },
                    [
                      _c("div", { staticClass: "row col-12 pr-0" }, [
                        _c("div", { staticClass: "row col-8" }, [
                          _c("div", { staticClass: "row col-12 col-md-6" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "data-title d-block border-mobile"
                                },
                                [_vm._v(" Documento: ")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-16 color-black" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("empty")("Carta de Autorización")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ])
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-4 d-flex align-items-center justify-content-end pr-0"
                          },
                          [
                            _c("action-button", {
                              attrs: {
                                i: "fas fa-download p-1",
                                variant: "success download-btn"
                              },
                              on: { click: _vm.onDownloadRefundReport }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._l(_vm.model.documents, function(item, index) {
                return [
                  !_vm.isReimbursementCertification(item.documentTypeId)
                    ? _c("validation-provider", {
                        key: `doc-validate-${index}`,
                        attrs: {
                          "custom-messages": {
                            required_if: _vm.docValidationMessage(item)
                          },
                          disabled: _vm.isOther(item) ? "disabled" : false,
                          rules: { required_if: item.documentId }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("reinbursement-documents", {
                                    key: index,
                                    attrs: {
                                      "auto-upload": false,
                                      item: item,
                                      "proposal-documents": _vm.getProposalDocumentByDocumentTypeId(
                                        item.documentTypeId
                                      ),
                                      "request-id": _vm.data.requestId
                                    },
                                    on: {
                                      "on-refresh-data": _vm.onUpdateDocument
                                    }
                                  }),
                                  errors[0] && errors[0].length > 0
                                    ? _c("custom-error", {
                                        attrs: {
                                          message: "El documento es requerido.",
                                          variant: "no-border"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : item.documentId
                    ? _c("DocumentView", {
                        key: `cert-doc-${index}`,
                        attrs: {
                          "can-add-document": false,
                          "document-file-name": item.documentFilename,
                          "document-id": item.documentId,
                          "document-name": item.documentTypeName,
                          "document-type-id": item.documentTypeId,
                          "request-id": _vm.data.requestId,
                          "show-replace-button": false
                        }
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }